import React from "react";
import { useHistory } from "react-router-dom";
import * as S from "./styles";
import { IRtv } from "interfaces/rtv";
import { useTranslation, usePermissions } from "hooks";
import { translations } from "./translations";

interface IGridCarriersProps {
  rtvs: IRtv[] | Record<string, any>[];
}

interface ItemProps {
  rtv: IRtv | Record<string, any>;
}

const Item: React.FC<ItemProps> = ({ rtv }) => {
  const history = useHistory();
  const { checkUserPermission } = usePermissions();
  const havePermission = checkUserPermission("editRTV");
  return (
    <S.ItemContainer
      onClick={() => havePermission && history.push(`/settings/rtv/${rtv.id}`)}
    >
      <S.ItemContent pointer={havePermission}>
        <S.ItemValue>{rtv.cod_rtv}</S.ItemValue>
        <S.ItemValue>{rtv.rtv_gr}</S.ItemValue>
        <S.ItemValue>{rtv.regional.name}</S.ItemValue>

        {havePermission && (
          <S.ButtonDetail>
            <S.IconDetail />
          </S.ButtonDetail>
        )}
      </S.ItemContent>
    </S.ItemContainer>
  );
};

export const GridRTV: React.FC<IGridCarriersProps> = ({ rtvs = [] }) => {
  const { getTranslation } = useTranslation(translations);
  return (
    <S.Container>
      <S.Header>
        <S.Label>{getTranslation("rtv")}</S.Label>
        <S.Label>{getTranslation("rtv_gr")}</S.Label>
        <S.Label>{getTranslation("regional")}</S.Label>
      </S.Header>
      {rtvs.length > 0 && rtvs.map((rtv) => <Item rtv={rtv} key={rtv.id} />)}
    </S.Container>
  );
};
